export default __webpack_public_path__ + "2ee11c939da164da0b515a601402a3d4f50551586a401705892d5a6d382452c4.png";